define.alias("ember-math-helpers/helpers/max", "settings/helpers/max");